import React from "react";
import Footer from "../../SubComponents/footer";
import Header from "../../SubComponents/Header";
import TajikistanMap from "../../SubComponents/SubcoverMap/coverage_map";
import Video from "../../assets/img/welcome.mp4";
import CompanentMaps from "../../SubComponents/SubcoverMap/CompanentMaps";

const CoverMapMain = () => {
  return (
    <>
      <div className="position-relative white-text" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>

      <div className="my-4 d-flex justify-content-center">
        <TajikistanMap />
      </div>
      <CompanentMaps />
      <Footer />
    </>
  );
};

export default CoverMapMain;
